import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getImagesByAlbum } from "../../api/requests";
import { Card, Container, Row, Col, Modal, Button } from "react-bootstrap";

const Gallery = ({ urls }) => {
    const { id } = useParams();  // Album-ID aus der URL
    const [images, setImages] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (urls && urls.length > 0) {
            // Static gallery mode
            setImages(urls.map((url, idx) => ({
                id: idx,
                image: url,
                title: "",
                photographer: "",
                description: "",
                is_public: true
            })));
        } else if (id) {
            // Dynamic gallery mode
            const fetchImages = async () => {
                try {
                    const imageData = await getImagesByAlbum(id);
                    // Fallback: falls imageData ein Objekt mit results ist
                    const imagesArr = Array.isArray(imageData)
                        ? imageData
                        : (Array.isArray(imageData?.results) ? imageData.results : []);
                    const publicImages = imagesArr.filter(img => img.is_public);
                    setImages(publicImages);
                } catch (err) {
                    console.error("Fehler beim Laden der Bilder:", err);
                    setImages([]);
                }
            };
            fetchImages();
        }
    }, [id, urls]);

    const openViewer = (index) => {
        setCurrentIndex(index);
        setSelectedImage(images[index]);
    };

    const closeViewer = () => setSelectedImage(null);

    const showNext = () => {
        if (currentIndex < images.length - 1) {
            setCurrentIndex(currentIndex + 1);
            setSelectedImage(images[currentIndex + 1]);
        }
    };

    const showPrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
            setSelectedImage(images[currentIndex - 1]);
        }
    };

    return (
        <Container>
            <h2>Album Galerie</h2>
            <Row>
                {images.map((image, index) => (
                    <Col key={image.id} xs={12} sm={6} md={4} lg={3}>
                        <Card onClick={() => openViewer(index)} style={{ cursor: "pointer" }} className="mb-3">
                            <Card.Img variant="top" src={image.image} />
                            <Card.Body>
                                <Card.Title>{image.title}</Card.Title>
                                <Card.Text><small>© {image.photographer}</small></Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            {/* Modal-Viewer */}
            <Modal show={!!selectedImage} onHide={closeViewer} centered size="lg">
                <Modal.Body className="text-center">
                    {selectedImage && (
                        <>
                            <img
                                src={selectedImage.image}
                                alt={selectedImage.title}
                                className="img-fluid"
                                style={{ maxHeight: "80vh" }}
                            />
                            <p className="mt-2">{selectedImage.title}</p>
                            <p>{selectedImage.description}</p>
                            <p><small>© {selectedImage.photographer}</small></p>
                            <div>
                                <Button variant="secondary" onClick={showPrev} disabled={currentIndex === 0}>◀ Zurück</Button>
                                <Button variant="secondary" onClick={showNext} disabled={currentIndex === images.length - 1} className="ms-2">Weiter ▶</Button>
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </Container>
    );
};

export default Gallery;
